// DOM Ready
$(function() {
  $(".fil-image-back-btn").click(function() { 
    $(this).hide();
    $(".foos-choose-model").html("").text("Change Model").removeClass("foos-choose-model-back");
    if(document.documentElement.clientWidth < 768) { 
			
			$('.mobile-view').slick('unslick');
			var html = $("#ks_slider_main").html();			
			$('.mobile-view').empty();
			$('.mobile-view').html(html);		
			
			var slideWrapperLoadSizeImagesMobile = $(".mobile-view"),
				iframes = slideWrapperLoadSizeImagesMobile.find('.embed-player'),
				lazyImages = slideWrapperLoadSizeImagesMobile.find('.slide-image'),
				lazyCounter = 0;	
			setTimeout(function(){
				playPauseVideoMobile(slideWrapperLoadSizeImagesMobile,"play");	
				resizePlayerMobile(iframes, 16/9); 			
			}, 1000); 
			
			
			/*slideWrapperLoadSizeImagesMobile.on("init", function(slick){
				slick = $(slick.currentTarget);				
				setTimeout(function(){
					playPauseVideoMobile(slick,"play");					
				}, 1000);
				resizePlayerMobile(iframes, 16/9);
			});*/
			slideWrapperLoadSizeImagesMobile.on("beforeChange", function(event, slick) {
				slick = $(slick.$slider);				
				playPauseVideoMobile(slick,"pause");   
			});
			slideWrapperLoadSizeImagesMobile.on("afterChange", function(event, slick) {
				slick = $(slick.$slider);
				playPauseVideoMobile(slick,"play");
			});
			slideWrapperLoadSizeImagesMobile.on("lazyLoaded", function(event, slick, image, imageSource) {
				lazyCounter++;
				if (lazyCounter === lazyImages.length){
					lazyImages.addClass('show');
					//slideWrapper.slick("slickPlay");
				}
			});
		
			$('.mobile-view').slick({
			// fade:true,
			autoplaySpeed:4000,
			lazyLoad:"progressive",
			speed:600,
			arrows:false,
			loop: false,
			infinite: false,
			swipe: true,  
			prevArrow: '<div class="slick-prev"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow"></path></svg></div>',
			nextArrow: '<div class="slick-next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>',
			dots:true,  			    
			cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)"
		});
			$('.mobile-view').slick('refresh');				
		} else {
			
			var html = $("#ks_slider_main").html();
			$(".desktop-view").empty();
			$(".desktop-view").append(html);      
							
			setTimeout(function(){
              var slideWrapperLoadSizeImagesDesktop = $(".desktop-view"),
                  iframes = slideWrapperLoadSizeImagesDesktop.find('.embed-player'),
                  lazyImages = slideWrapperLoadSizeImagesDesktop.find('.slide-image'),
                  lazyCounter = 0;
				playPauseVideoDesktop(slideWrapperLoadSizeImagesDesktop,"play");	
				resizePlayerDesktop(iframes, 16/9);			
			}, 1000); 	
		
		}
  });
  $('.product-fits-like > p').css('display', 'none');
  var ks_selected_val = $("variant-radios input[type='radio']:checked").val();	
  if(ks_selected_val) {
    //$('.fits_like_'+ks_selected_val).show();
  }
  	/* On Size variant click show the Fits Like text */
  	$("variant-radios input[type='radio']").click(function() {
      
      //$('.product-fits-like > p').css('display', 'none');
      //$('.fits_like_'+$(this).val()).show();
            
		//if(window.innerWidth < 768) {
          
        //} else {
        	
        //}
		//var html = $(".product-main-images").html();
        //$(".desktop-view").empty();
        //$(".desktop-view").append(html);
      });
  
  
 	 
  	/* On Product Change Model Start */
	$(".foos-choose-model").click(function() {     
   		$("#select-different-fit-style").children('li').toggle();
    });

    var allOptions = $("#select-different-fit-style").children('li');
    
	$("#select-different-fit-style").on("click", "li", function() {

        allOptions.removeClass('selected');
		var $this = $(this);
		$this.addClass('selected');
        var value = $this.attr('data-value');
		if(value == '') return;      
        $(".fil-image-back-btn").show();
		$(".foos-choose-model").html($(this).html()).addClass("foos-choose-model-back");
        allOptions.toggle(); 
		if(document.documentElement.clientWidth < 768) {
			
			$('.mobile-view').slick('unslick');
			var html = $("#fil_size_variant_"+value).html();			
			$('.mobile-view').empty();
			$('.mobile-view').html(html);		
			
			var slideWrapperLoadSizeImagesMobile = $(".mobile-view"),
				iframes = slideWrapperLoadSizeImagesMobile.find('.embed-player'),
				lazyImages = slideWrapperLoadSizeImagesMobile.find('.slide-image'),
				lazyCounter = 0;	
			setTimeout(function(){
				playPauseVideoMobile(slideWrapperLoadSizeImagesMobile,"play");	
				resizePlayerMobile(iframes, 16/9); 			
			}, 1000); 
			
			
			/*slideWrapperLoadSizeImagesMobile.on("init", function(slick){
				slick = $(slick.currentTarget);				
				setTimeout(function(){
					playPauseVideoMobile(slick,"play");					
				}, 1000);
				resizePlayerMobile(iframes, 16/9);
			});*/
			slideWrapperLoadSizeImagesMobile.on("beforeChange", function(event, slick) {
				slick = $(slick.$slider);				
				playPauseVideoMobile(slick,"pause");   
			});
			slideWrapperLoadSizeImagesMobile.on("afterChange", function(event, slick) {
				slick = $(slick.$slider);
				playPauseVideoMobile(slick,"play");
			});
			slideWrapperLoadSizeImagesMobile.on("lazyLoaded", function(event, slick, image, imageSource) {
				lazyCounter++;
				if (lazyCounter === lazyImages.length){
					lazyImages.addClass('show');
					//slideWrapper.slick("slickPlay");
				}
			});
		
			$('.mobile-view').slick({
			// fade:true,
			autoplaySpeed:4000,
			lazyLoad:"progressive",
			speed:600,
			arrows:false,
			loop: false,
			infinite: false,
			swipe: true,  
			prevArrow: '<div class="slick-prev"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow"></path></svg></div>',
			nextArrow: '<div class="slick-next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>',
			dots:true,  			    
			cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)"
		});
			$('.mobile-view').slick('refresh');				
		} else {
			
			var html = $("#fil_size_variant_"+value).html();
			$(".desktop-view").empty();
			$(".desktop-view").append(html);      
							
			setTimeout(function(){
              var slideWrapperLoadSizeImagesDesktop = $(".desktop-view"),
                  iframes = slideWrapperLoadSizeImagesDesktop.find('.embed-player'),
                  lazyImages = slideWrapperLoadSizeImagesDesktop.find('.slide-image'),
                  lazyCounter = 0;
				playPauseVideoDesktop(slideWrapperLoadSizeImagesDesktop,"play");	
				resizePlayerDesktop(iframes, 16/9);			
			}, 1000); 	
		
		}
		
	
	});
	/* On Product Change Model End */

	/* Mobile Load */
	if(document.documentElement.clientWidth < 768) {
		$(".main-slider").addClass('mobile-view');
		$(".main-slider").removeClass('desktop-view');
		
		var slideWrapperLoadMobile = $(".mobile-view"),
			iframes = slideWrapperLoadMobile.find('.embed-player'),
			lazyImages = slideWrapperLoadMobile.find('.slide-image'),
			lazyCounter = 0;
		
		
		slideWrapperLoadMobile.slick({  
			// fade:true,
			autoplaySpeed:4000,
			lazyLoad:"progressive",
			speed:600,
			arrows:false,
			loop: false,
			infinite: false,
			swipe: true,  
			prevArrow: '<div class="slick-prev"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow"></path></svg></div>',
			nextArrow: '<div class="slick-next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>',
			dots:true,  			    
			cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)"
		});

		// Initialize
		//slideWrapperLoadMobile.on("init", function(slick){
			//slick = $(slick.currentTarget);				
			setTimeout(function(){             
				playPauseVideoMobile(slideWrapperLoadMobile,"play");
resizePlayerMobile(iframes, 16/9);								
			}, 1000);
				
			
		//});
		slideWrapperLoadMobile.on("beforeChange", function(event, slick) {
			slick = $(slick.$slider);				
			playPauseVideoMobile(slick,"pause");
		});
		slideWrapperLoadMobile.on("afterChange", function(event, slick) {
			slick = $(slick.$slider);
			playPauseVideoMobile(slick,"play");
		});
		slideWrapperLoadMobile.on("lazyLoaded", function(event, slick, image, imageSource) {
			lazyCounter++;
			if (lazyCounter === lazyImages.length){
				lazyImages.addClass('show');
				//slideWrapper.slick("slickPlay");
			}
		});

      
      
		//@set slick-initialized
		//if(!$('.slider').hasClass('slick-initialized')){
			//mobileOnlySlider();
		//}

	} else {
      	/* Desktop Load */
      	
		$(".main-slider").addClass('desktop-view');
		$(".main-slider").removeClass('mobile-view');
		
		var slideWrapperLoadDesktop = $(".desktop-view"),
			iframes = slideWrapperLoadDesktop.find('.embed-player'),
			lazyImages = slideWrapperLoadDesktop.find('.slide-image'),
			lazyCounter = 0;		
		
		//@unset slick
		//if($('.slider').hasClass('slick-initialized')){
			//$('.slider').slick('unslick');
		//}
			
	
		// Initialize
		setTimeout(function(){
			playPauseVideoDesktop(slideWrapperLoadDesktop,"play");				
		}, 1000); 
		//resizePlayerDesktop(iframes, 16/9);				
		
	}
});	

//@Desktop POST commands to YouTube or Vimeo API
function postMessageToPlayerDesktop(player, command){
	if (player == null || command == null) return;
	player.contentWindow.postMessage(JSON.stringify(command), "*");
}
//@Desktop When the size is changing
function playPauseVideoDesktop(slick, control) {
	
	var currentSlide, slideType, startTime, player, video;

	//currentSlide = slick.find(".video-play");
	currentSlide = slick;
	if(currentSlide.find(".video-play").length > 0) {
		slideType = currentSlide.find(".video-play").attr("class").split(" ")[1];				
	} else {
		slideType = '';			
	}	
  	
	if(currentSlide.find("iframe").length > 0) {
		player = currentSlide.find("iframe").get(0);
	} else {
		player = '';
	}
	
	if(currentSlide.find(".video-play").length > 0) {
		startTime = currentSlide.find(".video-play").data("video-start");
	} else {
		startTime = '';
	}
  	
	//slideType = currentSlide.attr("class").split(" ")[1];		
	//player = currentSlide.find("iframe").get(0);
	//startTime = currentSlide.data("video-start");

	if (slideType === "vimeo") {
		
		switch (control) {
			case "play":
			if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
				postMessageToPlayerDesktop(player, {
					"method": "setCurrentTime",
					"value" : startTime
				});
			}
			postMessageToPlayerDesktop(player, {
			  "method": "play",
			  "value" : 1
			});
			break;
			case "pause":
			postMessageToPlayerDesktop(player, {
				"method": "pause",
				"value": 1
			});
			break;
		}
	} else if (slideType === "youtube") {
		switch (control) {
			case "play":
			postMessageToPlayerDesktop(player, {
				"event": "command",
				"func": "mute"
			});
			postMessageToPlayerDesktop(player, {
				"event": "command",
				"func": "playVideo"
			});
			break;
			case "pause":
			postMessageToPlayerDesktop(player, {
				"event": "command",
				"func": "pauseVideo"
			});
			break;   
		}
	} else if (slideType === "video") {
		video = currentSlide.children("video").get(0);
		if (video != null) {
			if (control === "play"){
				video.play();
			} else {
				video.pause();
			}
		}
	}
}	
//@Desktop Resize player
function resizePlayerDesktop(iframes, ratio) {
	if (!iframes[0]) return;

	var win = $(".desktop-view"),
		width = win.width(),
		playerWidth,
		height = $(".desktop-view .index_1").height(),
		playerHeight,
		ratio = ratio || 16/9;

        console.log("height" + height);
  		
		iframes.each(function(){
			var current = $(this);
			if (width / ratio < height) {
				playerWidth = Math.ceil(height * ratio);
				current.width(playerWidth).height(height).css({
					left: (width - playerWidth) / 2,
					top: 0	
				});
			} else {
				playerHeight = Math.ceil(width / ratio);
				current.width(width).height(playerHeight).css({
					left: 0,
					top: (height - playerHeight) / 2
				});
			}
		});
}	

//@Mobile POST commands to YouTube or Vimeo API
function postMessageToPlayerMobile(player, command){
	if (player == null || command == null) return;
	player.contentWindow.postMessage(JSON.stringify(command), "*");
}
//@Mobile When the slide is changing
function playPauseVideoMobile(slick, control){
	var currentSlide, slideType, startTime, player, video;
  
	currentSlide = slick.find(".slick-current");
  	slideType = currentSlide.attr("class").split(" ")[1];
  
	if(currentSlide.find("iframe").length > 0) {
		player = currentSlide.find("iframe").get(0);
	} else {
		player = '';
	}
     
	if (slideType === "vimeo") {
		startTime = currentSlide.data("video-start");
		switch (control) {
			case "play":
			if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
				currentSlide.addClass('started');
				postMessageToPlayerMobile(player, {
					"method": "setCurrentTime",
					"value" : startTime
				});
			}
			postMessageToPlayerMobile(player, {
				"method": "play",
				"value" : 1
			});
			break;
			case "pause":
			postMessageToPlayerMobile(player, {
				"method": "pause",
				"value": 1		
			});
			break;
		}
	} else if (slideType === "youtube") {
		startTime = currentSlide.data("video-start");
		switch (control) {
			case "play":
			postMessageToPlayerMobile(player, {
				"event": "command",
				"func": "mute"
			});
			postMessageToPlayerMobile(player, {
				"event": "command",
				"func": "playVideo"
			});
			break;
			case "pause":
			postMessageToPlayerMobile(player, {
				"event": "command",
				"func": "pauseVideo"
			});
			break;
		}		
	} else if (slideType === "video") {
		startTime = currentSlide.data("video-start");
		video = currentSlide.children("video").get(0);
		if (video != null) {
			if (control === "play"){
				video.play();
			} else {
				video.pause();
			}
		}
	}
}
//@Mobile Resize player
function resizePlayerMobile(iframes, ratio) {
	if (!iframes[0]) return;
 
		
	var win = $(".mobile-view"),
		width = win.width(),
		playerWidth,
		height = $(".mobile-view .index_1").height(),
		playerHeight,
		ratio = ratio || 16/9;
        console.log("height" + height);
	iframes.each(function(){
		var current = $(this);
		if (width / ratio < height) {
			playerWidth = Math.ceil(height * ratio);
			current.width(playerWidth).height(height).css({
				left: (width - playerWidth) / 2,
				top: 0
			});
		} else {
			playerHeight = Math.ceil(width / ratio);
			current.width(width).height(playerHeight).css({
				left: 0,
				top: (height - playerHeight) / 2
			});
		}
	});
}
 